import * as actions from "./actionsTypes";
import FormResponsesServices from "./dncActions.services";
import toastr from "toastr";
import messages from "../../messages";
import axios from "axios";

export const getFormResponses =
  (filters = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: true });
      const response = await FormResponsesServices.getFormResponses(filters);
      dispatch({
        type: actions.GET_FORM_RESPONSES,
        payload: {
          responses: response.data.data || response.data,
          responsesLength: response.data.count || response.data.length,
        },
      });
    } catch (error) {
      handleError(error, dispatch, actions.FORM_RESPONSES_FAIL);
    } finally {
      dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: false });
    }
  };

export const createFormResponse = (data) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: true });
    const response = await FormResponsesServices.createFormResponse(data);
    dispatch({ type: actions.CREATE_FORM_RESPONSE, payload: response.data });
    toastr.success(messages.successMessage);
    return response.data;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_RESPONSES_FORM_FAIL);
    throw error;
  } finally {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: false });
  }
};

export const changeQuestionStatus = (data, id) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: true });
    const response = await FormResponsesServices.changeStatusQuestions(data, id);
    dispatch({ type: actions.CHANGE_QUESTION_STATUS, payload: response.data });
    toastr.success(messages.successMessage);
    return response.data;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_RESPONSES_FAIL);
    throw error;
  } finally {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: false });
  }
};

export const createFormQuestion = (data) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: true });
    const response = await FormResponsesServices.createQuestionForm(data);
    dispatch({ type: actions.CREATE_FORM_QUESTION, payload: response.data });
    toastr.success(messages.successMessage);
    return response.data;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_RESPONSES_FORM_FAIL);
    throw error;
  } finally {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: false });
  }
};

export const editFormQuestion = (data, id) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: true });
    const response = await FormResponsesServices.editQuestionForm(data, id);
    dispatch({ type: actions.EDIT_FORM_QUESTION, payload: response.data });
    toastr.success(messages.successMessage);
    return response.data;
  } catch (error) {
    handleError(error, dispatch, actions.FORM_RESPONSES_FORM_FAIL);
    throw error;
  } finally {
    dispatch({ type: actions.SAVE_LOADING_FORM_RESPONSES, payload: false });
  }
};

export const getEmployeeForm =
  (filters = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: true });
      const response = await FormResponsesServices.getFormEmployee(filters);
      dispatch({
        type: actions.GET_EMPLOYEE_FORM,
        payload: response.data,
      });
    } catch (error) {
      handleError(error, dispatch, actions.FORM_RESPONSES_FAIL);
    } finally {
      dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: false });
    }
  };

export const getFormQuestions = () => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: true });
    const response = await FormResponsesServices.getForm();
    dispatch({
      type: actions.GET_FORM_QUESTIONS,
      payload: response.data,
    });
  } catch (error) {
    handleError(error, dispatch, actions.FORM_RESPONSES_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_FORM_RESPONSES, payload: false });
  }
};

export const clearFormResponses = () => ({
  type: actions.CLEAR_FORM_RESPONSES,
});

const handleError = (error, dispatch, actionType) => {
  let message = null;
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          message = error.response.data.error;
          break;
        case 404:
          message = messages.errorMessage + " " + error.response.data.error;
          break;
        case 500:
          message = messages.errorMessage + " " + error.response.data.error;
          break;
        default:
          message = error.response.data;
          break;
      }
    } else {
      message =
        error.message === "Network Error"
          ? messages.networkError
          : error.message;
    }
  } else {
    message =
      error.message === "Network Error" ? messages.networkError : error.message;
  }
  dispatch({ type: actionType, payload: message });
  toastr.error(message);
};